var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 6.87793L1.77241 11.1055C1.65703 11.2209 1.512 11.2799 1.33732 11.2826C1.16266 11.2853 1.01496 11.2262 0.894239 11.1055C0.773503 10.9848 0.713135 10.8384 0.713135 10.6664C0.713135 10.4944 0.773503 10.3481 0.894239 10.2273L5.1218 5.99974L0.894239 1.77216C0.77885 1.65679 0.719822 1.51176 0.717155 1.33708C0.714475 1.16241 0.773503 1.01472 0.894239 0.893995C1.01496 0.773259 1.16132 0.712891 1.33332 0.712891C1.50532 0.712891 1.65168 0.773259 1.77241 0.893995L5.99999 5.12156L10.2276 0.893995C10.3429 0.778606 10.488 0.719578 10.6627 0.716911C10.8373 0.714231 10.985 0.773259 11.1057 0.893995C11.2265 1.01472 11.2868 1.16108 11.2868 1.33308C11.2868 1.50508 11.2265 1.65144 11.1057 1.77216L6.87818 5.99974L11.1057 10.2273C11.2211 10.3427 11.2802 10.4877 11.2828 10.6624C11.2855 10.8371 11.2265 10.9848 11.1057 11.1055C10.985 11.2262 10.8387 11.2866 10.6667 11.2866C10.4947 11.2866 10.3483 11.2262 10.2276 11.1055L5.99999 6.87793Z",
    fill: "#A82525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconRed);
export default __webpack_public_path__ + "static/media/close_icon_red.3887f0b54b17cc73e9a9b7574de14f74.svg";
export { ForwardRef as ReactComponent };